export default "__VITE_ASSET__68eccdb4__"